import type {ReactAction} from '@netx/core/bootstrap';
import {dispatcher} from '@netx/core-next/instance/dispatcher';
import {faArrowDownToBracket} from '@netx/core-icons';
import {canDownloadCurrentCartMetadata} from '../enablers';
import {CART_CURRENT_ACTION_LABELS} from '../locales';
import {CART_CURRENT_EVENT} from './constants';

export const cartActionExportAttributesDownloadIcon = faArrowDownToBracket;

/**
 * Export and download attributes from cart
 * @param params
 * @returns Action
 */
export const cartActionExportAttributesDownload = (
	params?: Partial<ReactAction>,
): ReactAction => ({
	name: 'cart-export-attributes-download',
	cb: () => dispatcher.trigger(CART_CURRENT_EVENT.EXPORT_ATTRIBUTES_DOWNLOAD),
	enableTest: () => canDownloadCurrentCartMetadata(),
	icon: cartActionExportAttributesDownloadIcon,
	get label() {
		return CART_CURRENT_ACTION_LABELS.EXPORT_ATTRIBUTES_DOWNLOAD;
	},
	...params,
});

export default cartActionExportAttributesDownload;
